<script>
import axios from "axios";
import DrawingLookup from '../utils/drawings.mjs';

export default {
  name: 'TechnicalDrawings',
  props: {
    dataUrl: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      fechtedResults: [],
      renderedResults: [],
      filterCategories: [],
      search: '',
      drawingLookup: null,
      lastSelectedFilterValue: '',
      loading: true,
    };
  },
  mounted() {
    const qs = new URL(document.location).searchParams;
     axios.get(`${this.$props.dataUrl}`).then((response) => {
        //console.log("response", response);
        this.fechtedResults = response.data.searchResults;
        const DrawingsLookup = new DrawingLookup(response.data.searchResults);
        this.drawingLookup = DrawingsLookup;
        this.filterCategories = this.drawingLookup.filters;
        // console.log(this.drawingLookup);
        
          this.loading = false;
        
        
        // this.performSearch(qs)
    });
    
  },
  methods: {
      performSearch(qs) {
        this.drawingLookup.findMatchingDrawingsByTerm(qs)
      },
      performFilter($event, type) {
        let value = $event.currentTarget.value;
        this.renderedResults = this.drawingLookup.findMatchesByFilterType(type, value);
        this.lastSelectedFilterValue = value;
      }
  }
};
</script>
